<div class="h-full flex flex-col bg-gray-50 pb-20 w-full mx-auto font-prompt">
  <!-- 1. Header บาร์ด้านบน -->
  <div class="relative w-full pt-10 pb-5 flex flex-col z-10 items-center select-none">
    <!-- ปุ่มย้อนกลับ -->
    <div class="absolute top-4 left-4 z-20">
      <button (click)="goback()"
        class="w-9 h-9 rounded-full bg-gray-50 hover:bg-gray-100 text-gray-700 flex items-center justify-center active:scale-95 transition-all outline-none">
        <img src="icons/arrow_back_black.svg" class="w-full h-full" />
      </button>
    </div>

    <!-- รูปอวตารโปรไฟล์ -->
    <div class="relative mt-2">
      <div
        class="w-24 h-24 rounded-full overflow-hidden border-4 border-white shadow-lg flex items-center justify-center bg-gray-200 cursor-pointer">
        <img *ngIf="pictureUrl; else fallbackAvatar" [src]="pictureUrl" alt="Avatar" class="w-full h-full object-cover">
        <ng-template #fallbackAvatar>
          <img src="icons/person_slate.svg" />
        </ng-template>
      </div>
      <!-- ปุ่มเปลี่ยนรูปภาพ -->
      <!-- <button (click)="fileInput.click()"
        class="absolute bottom-0 right-0 w-8 h-8 bg-amber-500 text-white rounded-full shadow-md flex items-center justify-center hover:bg-amber-600 active:scale-90 transition-all border-2 border-white outline-none">
        <span class="material-symbols-outlined" style="font-size: 18px;">photo_camera</span>
      </button> -->
      <input #fileInput type="file" accept="image/*" class="hidden" (change)="onFileSelected($event)">
    </div>

    <!-- ชื่อผู้ใช้ LINE & ข้อมูลผู้ใช้ -->
    <h2 class="text-base font-bold text-gray-800 mt-3 tracking-wide">{{ displayName }}</h2>
    <!-- <p class="text-[10px] text-gray-400 font-medium tracking-wider mt-0.5">LINE USER ID: {{ uid | slice:0:12 }}...</p> -->
  </div>

  <!-- เส้นโค้งตกแต่งคลื่น (Wave Divider) -->
  <div class="w-full h-8 bg-white relative z-9">
    <svg class="absolute bottom-0 w-full h-8" viewBox="0 0 1440 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 24C240 -8 480 -8 720 24C960 56 1200 56 1440 24V74H0V24Z" fill="#F9FAFB" />
      <path opacity="0.3" d="M0 44C240 12 480 12 720 44C960 76 1200 76 1440 44V74H0V44Z" fill="#ffbb00" />
    </svg>
  </div>

  <!-- 2. รายการเมนูตั้งค่าและสิทธิ์ (Menu Lists) -->
  <div class="flex-1 bg-gray-50 px-6 pt-4 pb-24 space-y-3 text-left animation-slide-up-profile">

    <!-- แก้ไขข้อมูลส่วนตัว -->
    <div (click)="goEditProfile()"
      class="flex items-center justify-between p-4 bg-white rounded-2xl border border-gray-100/50 shadow-sm cursor-pointer hover:bg-amber-50/10 transition-all group">
      <div class="flex items-center gap-4">
        <span class="transition-colors"><img src="icons/person_slate_dark.svg" /></span>
        <span class="text-xs font-bold text-gray-700">{{ currentLang === "TH" ? "แก้ไขข้อมูลส่วนตัว" : "My Profile"
          }}</span>
      </div>
      <span class="transition-colors text-lg"><img src="icons/chevron_right_slate.svg" /></span>
    </div>

    <!-- การแจ้งเตือน -->
    <!-- <div (click)="goToNavigate('/notification')"
      class="flex items-center justify-between p-4 bg-white rounded-2xl border border-gray-100/50 shadow-sm cursor-pointer hover:bg-amber-50/10 transition-all group">
      <div class="flex items-center gap-4">
        <span class="material-symbols-outlined text-gray-400 group-hover:text-amber-500 transition-colors">mail_outline</span>
        <span class="text-xs font-bold text-gray-700">{{ currentLang === "TH" ? "การแจ้งเตือน" : "Messages" }}</span>
      </div>
      <div class="flex items-center gap-2">
        <span
          class="w-5 h-5 bg-amber-500 text-white text-[9px] font-bold rounded-full flex items-center justify-center shadow-sm"
          *ngIf="topUpData.notify > 0">
          {{ topUpData.notify }}
        </span>
        <span
          class="material-symbols-outlined text-gray-300 group-hover:text-gray-500 transition-colors text-lg">chevron_right</span>
      </div>
    </div> -->

    <!-- รถของฉัน -->
    <div (click)="goToNavigate('/vehicles-option')"
      class="flex items-center justify-between p-4 bg-white rounded-2xl border border-gray-100/50 shadow-sm cursor-pointer hover:bg-amber-50/10 transition-all group">
      <div class="flex items-center gap-4">
        <span class="transition-colors"><img src="icons/directions_car_slate_dark.svg" class="w-full h-full" /></span>
        <span class="text-xs font-bold text-gray-700">{{ currentLang === "TH" ? "รถของฉัน" : "My Vehicles" }}</span>
      </div>
      <span class="transition-colors text-lg"><img src="icons/chevron_right_slate.svg" /></span>
    </div>

    <!-- บัตรของฉัน -->
    <div (click)="goToNavigate('/my-member-card')"
      class="flex items-center justify-between p-4 bg-white rounded-2xl border border-gray-100/50 shadow-sm cursor-pointer hover:bg-amber-50/10 transition-all group">
      <div class="flex items-center gap-4">
        <span class="transition-colors"><img src="icons/credit_card_slate_dark.svg" class="w-full h-full" /></span>
        <span class="text-xs font-bold text-gray-700">{{ currentLang === "TH" ? "บัตรของฉัน" : "My Cards" }}</span>
      </div>
      <span class="transition-colors text-lg"><img src="icons/chevron_right_slate.svg" /></span>
    </div>

    <!-- ที่อยู่ออกใบกำกับภาษี -->
    <div (click)="goToNavigate('/address')"
      class="flex items-center justify-between p-4 bg-white rounded-2xl border border-gray-100/50 shadow-sm cursor-pointer hover:bg-amber-50/10 transition-all group">
      <div class="flex items-center gap-4">
        <span class="transition-colors"><img src="icons/place_slate_dark.svg" class="w-full h-full" /></span>
        <span class="text-xs font-bold text-gray-700">{{ currentLang === "TH" ? "ที่อยู่ออกใบกำกับภาษี" : "Location"
          }}</span>
      </div>
      <span class="transition-colors text-lg"><img src="icons/chevron_right_slate.svg" /></span>
    </div>

    <!-- ปิดหน้าต่าง / ออกจากระบบ -->
    <div (click)="closeLiffWindow()"
      class="flex items-center justify-center gap-2 pt-6 pb-4 text-gray-400 hover:text-red-500 active:scale-95 transition-all cursor-pointer select-none">
      <img src="icons/logout_slate_dark.svg" />
      <span class="text-xs font-bold">{{ currentLang === "TH" ? "ปิดหน้าต่าง LIFF" : "Close Window" }}</span>
    </div>
  </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>